export const META_DATA_COMPILER='NFTIV';export const QUERY_PARAMS_API_KEY='key';